<div
    style="display:flex; align-items:center; justify-content:space-between; gap: 12px; padding: 14px 16px; position: sticky; top: 0; background: var(--mat-sys-surface); z-index: 2; border-bottom: 1px solid var(--mat-sys-outline-variant);">
    <div>
        <div class="mat-mdc-card-title">Items Required</div>
        <div class="mat-mdc-card-subtitle subtitle-text-color-2 small-subtitle" style="line-height: 20px;">
            Edit and confirm the materials/items used for this ServiceRequest.
            @if(itemsRequiredSource === 'instance'){<span><b>Source:</b> Instance override</span>}
            @if(itemsRequiredSource === 'default'){<span><b>Source:</b> Default for this code</span>}
            @if(itemsRequiredSource === 'none'){<span><b>Source:</b> Not found</span>}
        </div>
    </div>

    <button mat-icon-button (click)="close()" aria-label="Close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div style="padding: 14px 16px;">
    @if(serviceRequestCompletedNote){
    <div class="subtitle-text-color-2 small-subtitle"
        style="margin: 8px 0 14px; padding: 10px 12px; border: 1px solid var(--mat-sys-outline-variant); border-radius: 10px; background: var(--mat-sys-surface-container-highest);">
        {{ serviceRequestCompletedNote }}
    </div>
    }

    @if(itemsRequiredReadOnlyNote){
    <div class="subtitle-text-color-2 small-subtitle"
        style="margin: 8px 0 14px; padding: 10px 12px; border: 1px solid var(--mat-sys-outline-variant); border-radius: 10px; background: var(--mat-sys-surface-container-highest);">
        {{ itemsRequiredReadOnlyNote }}
    </div>
    }

    @if(itemsRequiredLoading){
    <div style="display:flex; align-items:center; gap: 10px;" class="subtitle-text-color-2 small-subtitle">
        <mat-spinner diameter="20"></mat-spinner>
        Loading items required…
    </div>
    } @else {
    @if(!itemsRequiredForm || itemsRequiredForm.length === 0){
    <div class="subtitle-text-color-2 small-subtitle">Items required configuration is not available.</div>
    } @else {
    <app-resource-data-review
        [submittedData]="{itemsRequired: changeItemsRequiredRowsToResourceDataFormat(itemsRequiredRows)}"
        [resource]="{itemsRequired: changeItemsRequiredRowsToResourceDataFormat(itemsRequiredRows)}"
        [formFields]="itemsRequiredForm" [showEditButtons]="!editingLockedByServiceRequestCompletion"
        (resourceUpdated)="onItemsRequiredUpdatedFromReview($event)">
    </app-resource-data-review>
    }
    }

    <div class="button-group my-15 g-just-flex"
        style="justify-content: flex-end; width: 100%; gap: 14px; margin-top: 14px;">
        <button mat-stroked-button (click)="close()">Close</button>
        <button mat-flat-button color="primary" (click)="confirmItemsUsed()"
            [disabled]="itemsRequiredLoading || !itemsRequiredDirty || editingLockedByServiceRequestCompletion">Confirm
            Items Used</button>
    </div>
</div>